import * as React from 'react'

export const IconBuilding = () => (
  <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M14 8h3a3 3 0 0 1 3 3v11h-6V8Z' fill='#EEE6EF' />
    <path
      d='M4 7.342a3 3 0 0 1 2.272-2.91l6-1.5A3 3 0 0 1 16 5.842V22H4V7.342Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 17a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM8 13a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM8 9a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM2 21a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z'
      fill='#EEE6EF'
    />
  </svg>
)
